import styled, { css } from 'styled-components'

export const DashboardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 1rem 0 1rem;
  border-top: 1px solid #DADADA;
  gap: 1.5rem;

  ${props => props.bg && `
    background-color: ${props.bg};
    `}
  ${props => props.secondary && `
    padding: 0 1rem;
    border-top: none;
    margin-top: 32px;
  `}
`
export const BlockFlex = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ cardInfo }) => cardInfo && CardInfo}
  ${({ center }) => center && Center}
`
export const CardInfo = css`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0;
  flex: 1 65%;
  button {
    width: fit-content;
  }
  p {
    text-align: left;
  }
  `
export const Center = css`
  flex: 1;
  align-items: center;
  p {
    text-align: center;
  }
`

export const InfoTextContainer = styled.div`
  flex: 1 100%;
`
export const InfoText = styled.p`
  font-family: 'Open Sans';
  font-size: 0.75rem;
  line-height: 145%;
  max-width: 150px;
  margin: 0 auto;
  color: #555555;
  text-align: center;
  span {
    font-family: 'Open Sans';
  }
`
export const Avatar = styled.img`
  display: block;
`
export const Subtitle = styled.h2`
  font-size: 1rem;
  line-height: 120%;
  font-weight: 600;
  color: #222222;
  margin: 0 0 4px 0;
`
export const Text = styled.p`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: .875rem;
  line-height: 145%;
  text-align: center;
  margin: 0;
  ${({ mb }) => mb && 'margin-bottom: .5rem'}
`
export const Link = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Nunito';
  padding: 8px 8px;
  font-weight: 700;
  font-size: 1rem;
  line-height: 19px;
  letter-spacing: 0.96px;
  color: #01878E;
  background-color: transparent;
  border: none;
  flex: 1 100%;
  margin-top: ${({ marginTop }) => marginTop || '0px'};
  ${({ border }) => border && `
    padding: 6.5px 20px;
    border: 1px solid #01878E;
    border-radius: .5rem;
    flex: 0 1 auto;
  `}
  ${({ color }) => color && `
    color: ${color};
    border-color: ${color};
  `}
  ${({ left }) => left && `
    justify-content: flex-start;
  `}
`
export const Header = styled.div`
  margin-top:-10px;
  text-align: center;
  ${props => props.isSticky && 'position:fixed;top:0;left:0;right:0;z-index:1;padding:15px;'}
`
export const ReviewTitle = styled.span`
  font-size: 24px;
  font-weight: bold;
  text-align: center;
`
export const HorizontalLine = styled.hr`
  width: 100%;
  border-bottom: 1px solid #999999;
`
export const RatingAverage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  .react-simple-star-rating span svg {
    margin: 0 4px;
  }

  margin-bottom: 32px;
`

export const PreciseRatingAverage = styled.div`
  h2 {
    font-size: 48px;
    color: #222222;
  }
  text-align: center;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const EachRating = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TotalRatings = styled.div`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
  text-align: center;
  color: #555555;
  margin-top: 18px;
`
export const NoRatingWarning = styled.div`
  text-align: center;
  margin-bottom: 16px;
`
